import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

// The POS API base is .../api/v1/pos — strip the /pos suffix to reach the main API.
// GET /api/v1/organizations/:id returns the full org record including exchange/return settings.
const apiV1Base = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/pos$/, '');

export const orgSettingsApi = createApi({
  reducerPath: 'orgSettingsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['OrgSettings'],
  endpoints: (builder) => ({
    getOrgSettings: builder.query({
      // orgId required — pass auth.organization.id from the calling component
      query: (orgId) => `${apiV1Base}/organizations/${orgId}`,
      providesTags: [{ type: 'OrgSettings', id: 'CURRENT' }],
      // Response: { data: { id, return_reason_required, return_window_days, ... } }
      transformResponse: (response) => response?.data || {},
    }),
  }),
});

export const { useGetOrgSettingsQuery } = orgSettingsApi;

// Safe accessor — merges fetched org data with auth.organization fallbacks.
// Priority: fetched org API > auth.organization Redux state > safe defaults
export const resolveOrgSettings = (orgSettings = {}, authOrg = {}) => ({
  return_reason_required: orgSettings.return_reason_required ?? authOrg.return_reason_required ?? false,
  exchange_product_scope: orgSettings.exchange_product_scope ?? authOrg.exchange_product_scope ?? 'any_product',
  max_exchanges_per_order: orgSettings.max_exchanges_per_order ?? authOrg.max_exchanges_per_order ?? null,
  return_window_days: orgSettings.return_window_days ?? authOrg.return_window_days ?? null,
  return_refund_policy: orgSettings.return_refund_policy ?? authOrg.return_refund_policy ?? 'cashier_decides',
});
